module.exports = __webpack_public_path__ + "media/images/illustrations/prepworks-growth-be9c5b3cf0caca9f01ab44eddb30560c.svg";